import React from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
const ReconfigureStripeSepaSuccessUrl = () => {
  const { t } = useTranslation();
  return (
    <HelmetProvider>
      <Helmet
        titleTemplate={t('ReconfigureStripeSepaSuccessUrlTitleTemplate')}
        defaultTitle={t('ReconfigureStripeSepaSuccessUrlDefaultTitle')}
      />
      <h1>{t('ReconfigureStripeSepaSuccessUrlMessage')}</h1>
    </HelmetProvider>
  );
};
export default ReconfigureStripeSepaSuccessUrl;
